import {
  IDocumentMediaPreviewData,
  MESSAGE_CONTENT_TYPE,
} from "@home-health-notify/domain";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import { Box, Checkbox } from "@mui/material";
import React, { useContext } from "react";
import DocumentThumbBox from "../chatInfo/tabs/info/common/DocumentThumbBox";
import DisplayThumbnailImage from "../common/DisplayThumbnailImage";
import ScrollListContainer from "../common/ScrollListContainer";
import { DocumentMediaViewerContext } from "../context/DocumentMediaViewerContext";
import VideoThumb from "../message/mediaViewer/mediaThumb/VideoThumb";
import { MediaContainer, MediaItem, Overlay } from "./OrganizationMedia.style";

function OrganizationMediaListItem({
  media,
  onMediaClick,
  forwardMode,
  onMediaCheck,
  isSelected,
}: {
  media: IDocumentMediaPreviewData;
  onMediaClick: (media: IDocumentMediaPreviewData) => void;
  forwardMode: boolean;
  onMediaCheck: (media: IDocumentMediaPreviewData) => void;
  isSelected: boolean;
}) {
  const mediaData = media.media[0];
  const url = mediaData.url;
  return (
    <MediaItem>
      <Overlay>
        <span>{media.title}</span>
        {media.mediaType === MESSAGE_CONTENT_TYPE.VIDEO && (
          <PlayCircleFilledWhiteOutlinedIcon color="inherit" fontSize="large" />
        )}
      </Overlay>
      {forwardMode && (
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 100,
            background: "#fff",
            borderRadius: "10px 0 0 0",
          }}
        >
          <Checkbox
            checked={isSelected}
            style={{
              borderColor: "#fff",
              padding: 0,
            }}
            data-testid="media-checkbox"
            onChange={() => onMediaCheck(media)}
          />
        </Box>
      )}
      <Box
        onClick={() => {
          if (forwardMode) {
            onMediaCheck(media);
            return;
          }

          onMediaClick(media);
        }}
        style={{
          display: "flex",
        }}
      >
        {media.mediaType === MESSAGE_CONTENT_TYPE.IMAGE && (
          <DisplayThumbnailImage
            url={url}
            alt={media.title ?? ""}
            style={{
              width: "98%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        )}
        {media.mediaType === MESSAGE_CONTENT_TYPE.DOCUMENT && (
          <DocumentThumbBox
            fileName={media.title ?? ""}
            url={url}
            iconWidth={100}
          />
        )}
        {media.mediaType === MESSAGE_CONTENT_TYPE.VIDEO && (
          <VideoThumb
            isShowOverlay={false}
            videoData={{
              thumbnail: media.media[0].thumbnail ?? "",
              url,
              text: media.title ?? "",
            }}
            style={{
              width: "98%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        )}
      </Box>
    </MediaItem>
  );
}

const OrganizationMediaList = ({
  mediaList,
  forwardMode,
  onMediaCheck,
  onScroll,
  isMediaLoading,
  selectedMediaIds,
}: {
  mediaList: IDocumentMediaPreviewData[];
  forwardMode: boolean;
  onMediaCheck: (media: IDocumentMediaPreviewData) => void;
  onScroll: () => Promise<void>;
  isMediaLoading: boolean;
  selectedMediaIds: string[];
}) => {
  const { openDocumentMediaViewer } = useContext(DocumentMediaViewerContext);
  const onMediaClick = (media: IDocumentMediaPreviewData) => {
    openDocumentMediaViewer(media, mediaList);
  };
  return (
    <ScrollListContainer
      dataTestId="organization-media-list"
      onScrollCallback={onScroll}
      isLoading={isMediaLoading}
      restTop={130}
    >
      <MediaContainer>
        {mediaList.map((media: IDocumentMediaPreviewData) => {
          return (
            <OrganizationMediaListItem
              key={media.id}
              media={media}
              onMediaClick={onMediaClick}
              forwardMode={forwardMode}
              onMediaCheck={onMediaCheck}
              isSelected={selectedMediaIds.includes(media.id)}
            />
          );
        })}
      </MediaContainer>
    </ScrollListContainer>
  );
};

export default OrganizationMediaList;
